import { render } from "./help-page.vue?vue&type=template&id=6c8478ac&scoped=true"
import script from "./help-page.vue?vue&type=script&lang=js"
export * from "./help-page.vue?vue&type=script&lang=js"

import "./help-page.vue?vue&type=style&index=0&id=6c8478ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8478ac"]])

export default __exports__